import http from 'services/http-service';

const UmaiService = {
    GetPipelines() {
        var response = http.get("/ghl/pipelines");
        return response;
    }
};

export default UmaiService;